import {BaseOptions} from "../../../../dialog/options/base.options";

export class FeaturesOptions extends BaseOptions {
  product?: any;
  branchId?: any;
  onAddFinished?: any;
  servicePriceId?: any;
}
